var map = {
	"./Anyswap.png": 581,
	"./Anyswap.svg": 582,
	"./Artwork.svg": 583,
	"./Artwork_gmx.svg": 584,
	"./Banxa.png": 585,
	"./DROP_DOWN.svg": 350,
	"./Hop.png": 586,
	"./Hop.svg": 587,
	"./Hop_dark.png": 588,
	"./Hop_dark.svg": 589,
	"./LIF3Small.svg": 297,
	"./MetaMask.svg": 284,
	"./Synapse.png": 590,
	"./Synapse.svg": 591,
	"./binance.png": 592,
	"./bitkeep.svg": 593,
	"./bscscan.png": 594,
	"./btn_big_arbitrum.png": 595,
	"./btn_big_avalanche.png": 596,
	"./btn_big_bsc.png": 597,
	"./btn_big_purchasegmx.png": 598,
	"./btn_big_purchasegmx.svg": 599,
	"./buy-icon.svg": 600,
	"./buy_gmx.svg": 601,
	"./buy_gmx_bond.svg": 602,
	"./buy_transfer_eth.svg": 603,
	"./coinbaseWallet.png": 351,
	"./coingecko.png": 604,
	"./cross.svg": 605,
	"./dashboard-icon.svg": 352,
	"./dropdown.svg": 606,
	"./earn-icon.svg": 353,
	"./expert-bg.svg": 354,
	"./flag_en.svg": 607,
	"./flag_es.svg": 608,
	"./flag_fr.svg": 609,
	"./flag_ja.svg": 610,
	"./flag_ko.svg": 611,
	"./flag_ru.svg": 612,
	"./flag_zh.svg": 613,
	"./gateio.svg": 614,
	"./glp_icon.svg": 615,
	"./gmx-logo-final-white-small.png": 616,
	"./gmx-logo-final-white.png": 617,
	"./gmx-logo-final.png": 618,
	"./gmx-logo-glow.png": 619,
	"./gmx-logo-with-name.svg": 355,
	"./gmx_logo.svg": 620,
	"./graphite-01.png": 621,
	"./home-icon.svg": 622,
	"./ic-communityproject.svg": 623,
	"./ic_1inch.svg": 624,
	"./ic_across.svg": 625,
	"./ic_arbitrum_16.svg": 285,
	"./ic_arbitrum_24.svg": 431,
	"./ic_arbitrum_96.svg": 356,
	"./ic_arbitrum_hover_16.svg": 626,
	"./ic_arrowleft16.svg": 627,
	"./ic_arrowright16.svg": 628,
	"./ic_avalanche_16.svg": 286,
	"./ic_avalanche_24.svg": 432,
	"./ic_avalanche_96.svg": 357,
	"./ic_avalanche_testnet_16.svg": 629,
	"./ic_avalanche_testnet_24.svg": 630,
	"./ic_avalanche_testnet_96.svg": 631,
	"./ic_avax_24.svg": 632,
	"./ic_avax_30.svg": 633,
	"./ic_avax_40.svg": 634,
	"./ic_banxa.svg": 635,
	"./ic_binance.svg": 636,
	"./ic_binance_logo.svg": 637,
	"./ic_bnb_16.svg": 638,
	"./ic_bnb_24.svg": 639,
	"./ic_bnb_30.svg": 640,
	"./ic_bnb_40.svg": 641,
	"./ic_bnb_96.svg": 642,
	"./ic_boo_24.svg": 643,
	"./ic_boo_30.svg": 644,
	"./ic_boo_40.svg": 645,
	"./ic_bsc.svg": 646,
	"./ic_bsc_96.svg": 647,
	"./ic_btc.b_24.svg": 648,
	"./ic_btc.b_40.svg": 649,
	"./ic_btc_24.svg": 650,
	"./ic_btc_40.svg": 651,
	"./ic_bungee.png": 652,
	"./ic_busd_24.svg": 653,
	"./ic_busd_30.svg": 654,
	"./ic_busd_40.svg": 655,
	"./ic_buy_glp.svg": 433,
	"./ic_bybit.svg": 656,
	"./ic_cash.png": 657,
	"./ic_cash.svg": 658,
	"./ic_checked.svg": 358,
	"./ic_coingecko_16.svg": 359,
	"./ic_coingecko_hover_16.svg": 659,
	"./ic_convert_down.svg": 660,
	"./ic_copy_16.svg": 360,
	"./ic_cost.svg": 361,
	"./ic_dai_24.svg": 661,
	"./ic_dai_40.svg": 662,
	"./ic_discord.svg": 362,
	"./ic_dodo.svg": 663,
	"./ic_eth_24.svg": 664,
	"./ic_eth_40.svg": 665,
	"./ic_firebird.png": 666,
	"./ic_frax_24.svg": 667,
	"./ic_frax_40.svg": 668,
	"./ic_ftm_16.svg": 328,
	"./ic_ftm_24.svg": 434,
	"./ic_ftm_30.svg": 669,
	"./ic_ftm_40.svg": 435,
	"./ic_github.svg": 670,
	"./ic_glp_24.svg": 671,
	"./ic_glp_40.svg": 436,
	"./ic_glp_custom.svg": 672,
	"./ic_gmx.svg": 673,
	"./ic_gmx_24.svg": 674,
	"./ic_gmx_30.svg": 675,
	"./ic_gmx_40.svg": 437,
	"./ic_gmx_64.svg": 676,
	"./ic_gmx_arbitrum.svg": 677,
	"./ic_gmx_avax.svg": 678,
	"./ic_gmx_big.svg": 679,
	"./ic_gmx_custom.svg": 680,
	"./ic_gmx_footer.svg": 681,
	"./ic_hop.svg": 682,
	"./ic_huobi.svg": 683,
	"./ic_info.svg": 684,
	"./ic_instagram.svg": 363,
	"./ic_kucoin.svg": 685,
	"./ic_language24.svg": 239,
	"./ic_lif3_24.svg": 686,
	"./ic_lif3_30.svg": 687,
	"./ic_lif3_40.svg": 123,
	"./ic_link_24.svg": 688,
	"./ic_link_40.svg": 689,
	"./ic_liquidity.svg": 364,
	"./ic_llp_16.svg": 690,
	"./ic_llp_24.svg": 298,
	"./ic_llp_30.svg": 691,
	"./ic_llp_40.svg": 140,
	"./ic_matcha.png": 692,
	"./ic_medium.svg": 365,
	"./ic_menu_dots.svg": 693,
	"./ic_metamask_16.svg": 366,
	"./ic_metamask_hover_16.svg": 694,
	"./ic_mim_24.svg": 695,
	"./ic_mim_40.svg": 696,
	"./ic_multiswap.svg": 697,
	"./ic_new_link_16.svg": 367,
	"./ic_o3.png": 698,
	"./ic_odos.png": 699,
	"./ic_olympus.svg": 700,
	"./ic_olympus_arbitrum.svg": 701,
	"./ic_openocean.svg": 702,
	"./ic_paraswap.svg": 703,
	"./ic_selector_dropdowns.svg": 704,
	"./ic_settings_16.svg": 705,
	"./ic_settings_24.svg": 706,
	"./ic_sign in_16.svg": 707,
	"./ic_sign_out_16.svg": 368,
	"./ic_simpleswaps.svg": 369,
	"./ic_slingshot.svg": 708,
	"./ic_stats.svg": 370,
	"./ic_stats_big.svg": 709,
	"./ic_synapse.svg": 710,
	"./ic_telegram.svg": 371,
	"./ic_tether_24.svg": 711,
	"./ic_tokens.svg": 712,
	"./ic_totaluser.svg": 372,
	"./ic_traderjoe.png": 713,
	"./ic_trading.svg": 373,
	"./ic_transfer_avax.svg": 714,
	"./ic_twitter.svg": 374,
	"./ic_uni_24.svg": 715,
	"./ic_uni_40.svg": 716,
	"./ic_uni_arbitrum.svg": 717,
	"./ic_usdc.e_24.svg": 718,
	"./ic_usdc.e_40.svg": 719,
	"./ic_usdc_24.svg": 720,
	"./ic_usdc_40.svg": 721,
	"./ic_usdt_24.svg": 722,
	"./ic_usdt_40.svg": 723,
	"./ic_wallet_16.svg": 375,
	"./ic_wallet_24.svg": 724,
	"./ic_wallet_white_16.svg": 376,
	"./ic_wavax_24.svg": 725,
	"./ic_wavax_40.svg": 726,
	"./ic_wbnb_24.svg": 727,
	"./ic_wbnb_30.svg": 728,
	"./ic_wbnb_40.svg": 729,
	"./ic_wbtc_24.svg": 730,
	"./ic_wbtc_40.svg": 731,
	"./ic_weth_24.svg": 732,
	"./ic_weth_40.svg": 733,
	"./ic_wftm_16.svg": 734,
	"./ic_wftm_24.svg": 735,
	"./ic_wftm_30.svg": 736,
	"./ic_wftm_40.svg": 737,
	"./ic_yield_yak.png": 738,
	"./leaderboard-icon.svg": 377,
	"./lg_arbitrum.svg": 739,
	"./lif3-symbol.svg": 378,
	"./lifLogo.svg": 205,
	"./liquidity.svg": 740,
	"./logo_GMX.svg": 379,
	"./logo_GMX_small.svg": 741,
	"./long.svg": 380,
	"./longActive.svg": 381,
	"./lp-icon.svg": 382,
	"./metamask-text.svg": 742,
	"./metamask.png": 383,
	"./nansen_portfolio.svg": 384,
	"./page-not-found.svg": 743,
	"./position-share-bg.png": 385,
	"./positions-tab-active.svg": 240,
	"./positions-tab.svg": 241,
	"./powered-by.svg": 744,
	"./ref-icon.svg": 386,
	"./settings-icon.svg": 242,
	"./short.svg": 387,
	"./shortActive.svg": 388,
	"./sky.svg": 389,
	"./stats.svg": 390,
	"./swap.svg": 391,
	"./swapActive.svg": 392,
	"./trade-icon.svg": 393,
	"./traders-tab-active.svg": 243,
	"./traders-tab.svg": 244,
	"./trading.jpg": 745,
	"./wallet-connect-text.svg": 746,
	"./walletconnect-circle-blue.svg": 394,
	"./wave-01.png": 747,
	"./wave-02.png": 748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 580;